import { TypingTest } from './Modules/TypingTest';
import { WordProvider } from './Modules/WordProvider';
import { TypingTestApp } from './Modules/app';
import { SimpleScroller } from "./simpleScroller";

const wordProvider = new WordProvider(225);
const test = new TypingTest(wordProvider, 20);

const app = new TypingTestApp(test, new SimpleScroller('word-wrapper'));
